import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a30ef7b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "switch" }

interface EmitsType {
  (e: 'update:value', val: boolean): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
  on: {
    type: String,
    default: ''
  },
  off: {
    type: String,
    default: ''
  },
  value: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:value"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:value', val: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const update = () => {
  emit('update:value', !props.value);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "fl",
      onClick: update
    }, _toDisplayString(props.on), 1),
    _createElementVNode("div", {
      class: "fr",
      onClick: update
    }, _toDisplayString(props.off), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["fled", { 'right': !props.value }])
    }, _toDisplayString(props.value ? props.on : props.off), 3)
  ]))
}
}

})